export const createCSSPartsObjFromList = (
  parts: string[] = []
): Record<string, string> => {
  return parts.reduce<Record<string, string>>((accum, part) => {
    accum[part] = part;
    return accum;
  }, {});
};

export const createCSSPartsProxy = (
  cssPartsObj: Record<string, string> = {}
): Record<string, string> => {
  return new Proxy(cssPartsObj, {
    get(target, prop, receiver) {
      const value = target[prop as string];

      if (!value) {
        console.warn(`CSS part "${String(prop)}" is not defined`);
      }

      return Reflect.get(target, prop, receiver);
    },
    set() {
      console.warn('Not allowed to set values on this object');
      return true;
    },
    deleteProperty() {
      console.warn('Not allowed to delete values on this object');
      return true;
    }
  });
};
